import type { Reducer } from 'redux';
import type { SubscriptionState } from './subscriptionTypes';
import { SubscriptionActionTypes } from './subscriptionTypes';

export const initialState: SubscriptionState = {
  accountSubscription: null,
  isGettingAccountSubscription: false,
};

const subscriptionReducer: Reducer<SubscriptionState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SubscriptionActionTypes.REQUEST_GET_ACCOUNT_SUBSCRIPTION:
      return { ...state, isGettingAccountSubscription: true };
    case SubscriptionActionTypes.GET_ACCOUNT_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        accountSubscription: null,
        isGettingAccountSubscription: false,
      };
    case SubscriptionActionTypes.CLEAR_ACCOUNT_SUBSCRIPTION:
      return { ...state, accountSubscription: null };
    case SubscriptionActionTypes.GET_ACCOUNT_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        accountSubscription: action.payload.accountSubscription,
        isGettingAccountSubscription: false,
      };

    default:
      return state;
  }
};

export default subscriptionReducer;
